import React from "react";
import PropTypes from "prop-types";
import { Button, CircularProgress, Box, Typography } from "@mui/material";
import Navbar from "../../../../globals/components/Navbar";
import SupportRequestModal from "../../../../components/SupportRequestModal";
import { getSelectedStateLabel } from "../../Bond Creation/bondWizardPageConfig.shared";

/**
 * Shared historic bond create page shell (Navbar + title + sections + submit).
 */
export default function HistoricBondCreatePage({
  bondKindLabel,
  useCreateHook,
  sections,
  submitDisabled,
}) {
  const hookState = useCreateHook();
  const {
    isLoading,
    errors,
    supportModalOpen,
    setSupportModalOpen,
    submissionError,
    globalState,
    updateGlobalState,
    handleSubmit,
    handleSupportRequestSubmit,
    setErrors,
  } = hookState;

  const stateLabel = getSelectedStateLabel();
  const sectionCtx = { globalState, updateGlobalState, errors, setErrors, hookState };

  return (
    <>
      <Navbar />
      <Box className="p-6 max-w-4xl mx-auto">
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{ fontWeight: "bold" }}
        >
          {bondKindLabel} Bond Request for State of {stateLabel}
        </Typography>

        <Box className="space-y-8">
          {sections.map(({ key, render, Component, stateKey, sectionProps }) => {
            if (render) {
              return <React.Fragment key={key}>{render(sectionCtx)}</React.Fragment>;
            }
            return (
              <Component
                key={key}
                globalData={globalState}
                data={globalState[stateKey]}
                updateData={(data) => updateGlobalState(stateKey, data)}
                errors={errors}
                setErrors={setErrors}
                {...(sectionProps || {})}
              />
            );
          })}

          <Box className="flex justify-end mt-8">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSubmit}
              disabled={submitDisabled?.(globalState) ?? false}
              endIcon={isLoading && <CircularProgress size={20} />}
            >
              {isLoading ? "Processing..." : "Submit"}
            </Button>
          </Box>
        </Box>
      </Box>
      <SupportRequestModal
        open={supportModalOpen}
        onClose={() => setSupportModalOpen(false)}
        onSubmit={handleSupportRequestSubmit}
        errorMessage={submissionError}
      />
    </>
  );
}

HistoricBondCreatePage.propTypes = {
  bondKindLabel: PropTypes.string.isRequired,
  useCreateHook: PropTypes.func.isRequired,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      Component: PropTypes.elementType,
      stateKey: PropTypes.string,
      sectionProps: PropTypes.object,
      render: PropTypes.func,
    })
  ).isRequired,
  submitDisabled: PropTypes.func,
};
